import type { ExplorerSortConfig } from '../types/entities';
import type { useWorkspaceStore } from '../stores/workspace';
import { storeToRefs } from 'pinia';


export function useStructureActions(options: {
  store: ReturnType<typeof useWorkspaceStore>;
  newEntity: { templateId: string };
  revealTemplateInCategory: (templateId: string) => void;
}) {
  const { store, newEntity, revealTemplateInCategory } = options;
  const { templates } = storeToRefs(store);
async function submitCategory(input: { key: string; name: string; icon: string | null; color: string; showInExplorer: boolean }, done: (error?: string) => void) {
  try { await store.createCategory(input); done(); }
  catch (error) { done(error instanceof Error ? error.message : 'Kategorie konnte nicht gespeichert werden.'); }
}

async function submitTemplate(input: {
  key: string; name: string; category: string; icon: string | null;
  parentTemplateId: string | null; locationParentTemplateId?: string | null; locationParentSourceFieldKey?: string; fields: Array<Record<string, unknown>>; aiConfig: Record<string, unknown>; showInExplorer: boolean; isGroup: boolean; explorerSort: ExplorerSortConfig | null; developmentKind: 'goal' | 'attribute' | 'relationship' | null;
}, done: (error?: string) => void) {
  try {
    await store.createTemplate(input);
    const created = templates.value.find((item) => item.key === input.key);
    if (created) { newEntity.templateId = created.id; revealTemplateInCategory(created.id); }
    else if (!newEntity.templateId && templates.value[0]) newEntity.templateId = templates.value[0].id;
    done();
  } catch (error) { done(error instanceof Error ? error.message : 'Template konnte nicht gespeichert werden.'); }
}

async function updateCategory(categoryId: string, input: { name: string; icon: string | null; color: string; showInExplorer: boolean }, done: (error?: string) => void) {
  try { await store.updateCategory(categoryId, input); done(); }
  catch (error) { done(error instanceof Error ? error.message : 'Kategorie konnte nicht geändert werden.'); }
}

async function updateTemplate(templateId: string, input: {
  name: string; category: string; icon: string | null;
  parentTemplateId: string | null; locationParentTemplateId?: string | null; locationParentSourceFieldKey?: string; fields: Array<Record<string, unknown>>; aiConfig: Record<string, unknown>; showInExplorer: boolean; isGroup: boolean; explorerSort: ExplorerSortConfig | null; developmentKind: 'goal' | 'attribute' | 'relationship' | null; fieldRemovalMode?: 'remove-values';
}, done: (error?: string) => void) {
  try { await store.updateTemplate(templateId, input); done(); }
  catch (error) { done(error instanceof Error ? error.message : 'Template konnte nicht geändert werden.'); }
}

async function deleteCategory(categoryId: string, input: { mode: 'move' | 'delete'; targetCategoryId?: string }, done: (error?: string) => void) {
  try { await store.deleteCategory(categoryId, input); done(); }
  catch (error) { done(error instanceof Error ? error.message : 'Kategorie konnte nicht gelöscht werden.'); }
}
async function deleteTemplate(templateId: string, input: { mode: 'move' | 'delete'; targetTemplateId?: string }, done: (error?: string) => void) {
  try { await store.deleteTemplate(templateId, input); done(); }
  catch (error) { done(error instanceof Error ? error.message : 'Template konnte nicht gelöscht werden.'); }
}
function moveCategoryOrder(categoryId: string, direction: -1 | 1) { void store.moveCategory(categoryId, direction); }
function moveTemplateOrder(templateId: string, direction: -1 | 1) { void store.moveTemplate(templateId, direction); }
  return { submitCategory, submitTemplate, updateCategory, updateTemplate, deleteCategory, deleteTemplate, moveCategoryOrder, moveTemplateOrder };
}
